import { render, staticRenderFns } from "./CustomInputFour.vue?vue&type=template&id=2287f05c&"
import script from "./CustomInputFour.vue?vue&type=script&lang=js&"
export * from "./CustomInputFour.vue?vue&type=script&lang=js&"
import style0 from "./CustomInputFour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports